import Image from 'next/image';

export default function CardArt({ cardName, imageUrl }) {
  return (
    <div className="my-8 flex justify-center">
      <Image
        src={imageUrl}
        alt={`The ${cardName} tarot card`}
        width={280}
        height={467}
        priority
        className="rounded-lg shadow-lg w-full max-w-[14rem] md:max-w-[18rem]"
        quality={75}
        sizes="(max-width: 768px) 224px, 288px"
      />
    </div>
  );
} 